import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const PANEL_URL = import.meta.env.VITE_PANEL_URL?.replace(/\/+$/, "") ?? "https://panel.enabase.com";

export const SITE_LOGO_SRC = "/enabase-logo.png?v=2";
export const SITE_LOGO_DARK_SRC = "/enabase-logo-dark.png?v=2";
/** UI’da küçük marka ikonu — büyük favicon.png çekilmesin */
export const SITE_MARK_SRC = "/favicon-32.png?v=2";

/** External / non-locale paths only — use `@/lib/routes` for internal pages. */
export const LINKS = {
  register: `${PANEL_URL}/register`,
  login: `${PANEL_URL}/login`,
  email: "info@enabase.com",
  phone: "08508404520",
  phoneIntl: "908508404520",
} as const;

export const COMPANY_ADDRESS = {
  line1: "Caferağa, Şifa Sk No: 19",
  line2: "34710 Kadıköy/İstanbul",
  full: "Caferağa, Şifa Sk No: 19, 34710 Kadıköy/İstanbul",
} as const;

export const COMPANY_MAPS_URL = "https://maps.app.goo.gl/zv6dDuyupV6ZhXD2A";

/** www.enabase.com footer social profiles */
export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/enabasecom",
  instagram: "https://www.instagram.com/enabasecom/",
  linkedin: "https://www.linkedin.com/company/enabase/",
  youtube: "https://www.youtube.com/channel/UCkRg8CnpyprBm0fTLg9QtCQ",
  whatsapp: `https://wa.me/${LINKS.phoneIntl}`,
} as const;
